import { Alert, Button, Typography } from 'antd';
import React, { useEffect } from "react";
import { generatePath, useNavigate, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { ItemClientStatuses } from '../../../library/constants/ItemClientStatuses.js';
import style from './order-sent.module.scss';

const OrderSent = () => {
    const { orderDetails, itemDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const { getClientArtworks } = useOutletContext()
    const navigate = useNavigate()

    const hasArtwork = itemDetails?.client_status >= ItemClientStatuses.UPLOAD_ARTWORK || orderDetails?.has_artwork;

    useEffect(() => {
        let timer = null
        timer = setTimeout(() => {
            navigate(generatePath('/order-manager/:itemId/:stepId', {
                itemId: orderDetails.id,
                stepId: orderDetails.order_status
            }), {
                replace: true
            })
        }, 10 * 1000)
        return () => {
            clearTimeout(timer)
        }
    }, [orderDetails.order_status])

    return (
        <div className={style.container}>
            <h3>Task To do for Customer</h3>
            {!orderDetails.reminder_artwork && (
                <Alert
                    message={hasArtwork ? "Customer Artwork" : "Missing Artwork"}
                    description={hasArtwork ? "Customer has uploaded artwork" : "Reminder sent to customer to share the artwork"}
                    type="info"
                    showIcon
                    action={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <Button className={style.greenButton} onClick={getClientArtworks}>
                                View / Upload Artwork
                            </Button>
                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                {hasArtwork ? 'Artwork received' : 'No artwork yet'}
                            </Typography.Text>
                        </div>
                    }
                />
            )}
            {(orderDetails.request_for_address !== 2) && <Alert message="Missing delivery address" description="Reminder sent to customer to share the delivery address" type="info" showIcon />}
        </div>
    )
}

export default OrderSent;